import ResetView from "../view/reset.js";
import ResetModel from "../model/reset.js";

import {
  render,
  removeElement
} from "../../../render/render.js";

import {
  defaultResetModelData,
  ActionType,
  RESET_ANIMATION_DURATION,
  PAGINATION_KEY,
  VIEW_TYPE_KEY,
  LIMIT_KEY,
  SORT_KEY
} from "../../const.js";
export default class Reset {
  constructor(wrapperView, changeFilter, animation, scrollToElement, listingWrapperView) {
    this._wrapperView = wrapperView;
    this._changeFilter = changeFilter;
    this._animation = animation;
    this._scrollToElement = scrollToElement;
    this._listingWrapperView = listingWrapperView;

    this._resetView = null;
    this._resetModel = null;
    this._relativeScrollContainer = null;
    this._scrollElement = null;

    this._observers = [];
    this._items = [];

    this._changeFilterHandler = this._changeFilterHandler.bind(this);
    this._handleChangeModel = this._handleChangeModel.bind(this);
    this._handleButtonClick = this._handleButtonClick.bind(this);
  }

  addObserver(observer) {
    this._observers.push(observer);
  }

  removeObserver(observer) {
    this._observers = this._observers.filter((existedObserver) => existedObserver !== observer);
  }

  addItem(key, item) {
    if (!this._items[key]) {
      this._items[key] = [];
    }

    this._items[key].push(item);
  }

  checkReset() {
    let shouldRender = false;

    Object
      .entries(this._items)
      .forEach((entry) => {
        const key = entry[0];
        const items = entry[1];

        items.forEach((item) => {
          const modelData = item.getModelData();

          if (key === `sliders`) {
            if (modelData.isReset === false) {
              shouldRender = true;
            }
          } else if (key === `checkboxes`) {
            if (modelData.isSomeChecked) {
              shouldRender = true;
            }
          }
        })
      });

    if (shouldRender === false && this._resetModel.getData().isRendered) {
      this._resetModel.changeData(Object.assign(
          {},
          this._resetModel.getData(),
          {
            isRendered: false
          }
      ), ActionType.REMOVE_RESET);
      return;
    } else if (shouldRender === false && !this._resetModel.getData().isRendered) {
      return;
    }

    if (!this._resetModel.getData().isRendered) {
      this._resetModel.changeData(Object.assign(
          {},
          this._resetModel.getData(),
          {
            isRendered: true
          }
      ), ActionType.ADD_RESET);
    }
  }

  init() {
    this._resetView = new ResetView();
    this._resetModel = new ResetModel(Object.assign(
        {},
        defaultResetModelData
    ));
    this._resetModel.addObserver(this._handleChangeModel);
    this._changeFilter.addLoadEndObserver(this._changeFilterHandler);
  }

  setRelativeScrollElements(container, element) {
    this._relativeScrollContainer = container;
    this._scrollElement = element;
  }

  removeRelativeScrollElements() {
    this._relativeScrollContainer = null;
    this._scrollElement = null;
  }

  _changeFilterHandler() {
    this.checkReset();
  }

  _addButton() {
    const resetButton = this._resetView.getElement();
    render(this._wrapperView.getResetButtonWrapper(), resetButton);

    this._animation.fadeIn(
        resetButton
    );

    this._resetView.setClickHandler(this._handleButtonClick);
  }

  _removeButton() {
    const resetButton = this._resetView.getElement();
    this._resetView.removeElement();

    this._animation.fadeOut(
        resetButton,
        RESET_ANIMATION_DURATION,
        () => {
          removeElement(resetButton);
        }
    );
  }

  _notify() {
    this._observers.forEach((observer) => observer());
  }

  _handleChangeModel(action) {
    switch (action) {
      case ActionType.REMOVE_RESET:
        this._removeButton();
        break;
      case ActionType.ADD_RESET:
        this._addButton();
        break;
    }
  }

  _handleButtonClick() {
    this._notify();
    this._changeFilter.updateProductsData();

    const scrollOptions = {
      element: this._listingWrapperView.getElement()
    };

    if (this._relativeScrollContainer) {
      scrollOptions.relativeContainer = this._relativeScrollContainer;
      scrollOptions.element = this._scrollElement;
    }

    this._scrollToElement.scroll(scrollOptions);
  }
}
